import styled from 'styled-components';

import { ReactComponent as HelpIcon } from 'assets/images/ayuda.svg';
import { ReactComponent as Ayuda } from 'assets/images/ayuda.svg';
import { ReactComponent as Cambiar } from 'assets/images/cambiar.svg';
import { ReactComponent as Cancel } from 'assets/images/cancel.svg';
import { ReactComponent as Chevron } from 'assets/images/chevron-small.svg';
import { ReactComponent as CopyPaste } from 'assets/images/copy-paste.svg';
import { ReactComponent as Email } from 'assets/images/email2.svg';
import { ReactComponent as Historial } from 'assets/images/historial.svg';
import { ReactComponent as GoingIcon } from 'assets/images/ida.svg';
import { ReactComponent as Info } from 'assets/images/info-circle.svg';
import Button from 'components/Buttons/Button';

export const Header: any = styled.div``;

Header.Title = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #332927;
  text-align: center;
`;

Header.Subtitle = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;
  color: #332927;
  text-align: center;
`;

export const HeaderButton: any = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
`;
HeaderButton.Button = styled(Button)`
  width: 32px;
  height: 32px;

  background: #ffffff;

  box-shadow: 0px 5px 10px rgba(33, 34, 36, 0.04);
  border-radius: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
HeaderButton.Icon = styled(HelpIcon)`
  width: 20px;
  height: 20px;
  color: #332927;
  margin-top: 4px;
`;
HeaderButton.Label = styled.div`
  font-weight: 600;
  font-size: 10px;
  line-height: 140%;
  color: #332927;
  text-align: center;
`;

export const Container = styled.div`
  position: relative;
`;

type DestinationProps = {
  $image: string;
};
export const Destination = styled.div<DestinationProps>`
  background-image: ${({ $image }) => `url(${$image})`};
  background-position: center center;
  background-size: cover;
  width: 100%;
  height: 180px;
  border-radius: 0px 0px 8px 8px;
  position: absolute;
  top: -143px;
  left: 0;
  z-index: 1;
`;

export const GoingIn: any = styled.div`
  background: #fff;
  height: 32px;
  border-radius: 32px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
  gap: 8px;
  position: absolute;
  top: -127px;
  right: 16px;
  z-index: 2;
`;
GoingIn.Icon = styled(GoingIcon)`
  width: 18px;
  height: 18px;
  color: #332927;
`;
GoingIn.Text = styled.span`
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #332927;
`;
export const Wrapper = styled.div`
  position: relative;
  z-index: 3;
  margin: 213px 16px 16px;
  @media ${({ theme }) => theme.device.desktop} {
    margin-top: 143px;
  }
`;
export const Section: any = styled.section`
  display: flex;
  flex-direction: column;
`;
Section.Title = styled.h2`
  font-weight: 600;
  font-size: 20px;
  line-height: 120%;
  color: #332927;
  margin: 24px 0 16px;
`;
Section.Text = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  scolor: #332927;
`;

export const Content: any = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  background: #ffffff;
  box-shadow: 0px 5px 10px rgba(33, 34, 36, 0.04);
  border-radius: 12px;
  margin-bottom: 16px;
`;

Content.Header = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
Content.Title = styled.h1`
  font-weight: 600;
  font-size: 16px;
  line-height: 125%;
  color: #332927;
`;

Content.Image = styled.img`
  margin-right: 2px;
`;

export const Menu: any = styled.div`
  width: 100%;
`;
Menu.Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
Menu.Title = styled.h3`
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #332927;
`;
Menu.Text = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 130%;
  color: #706967;
`;
Menu.Group = styled.ul`
  margin-top: 16px;
`;
Menu.Item = styled.li`
  color: #332927;
  border-bottom: 1px solid #dbdbdb;
  padding: 16px 0;

  &:last-child {
    border-bottom: none;
  }
  &:first-child {
    border-top: 1px solid #dbdbdb;
  }
`;

type ContentProps = {
  $hide: boolean;
};

Menu.Content = styled.div<ContentProps>`
  display: ${({ $hide }) => `${$hide ? 'none' : 'flex'}`};
  justify-content: space-between;
  align-items: center;
`;
Menu.Icon = styled.div`
  margin-right: 6px;
  cursor: pointer;
`;
Menu.Code = styled.div`
  color: #332927;
  display: flex;
  justify-content: flex-start;
  font-weight: 600;
  font-size: 16px;
  line-height: 125%;
`;
Menu.Label = styled.div`
  color: #332927;
  display: flex;
  justify-content: flex-start;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  cursor: pointer;
`;
Menu.Arrow = styled.div``;
Menu.Dot = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2px;
  width: 8px;
  height: 8px;
  background: #F4BF31;
  border-radius: 80px;
  margin: 2px 0;
`;

export const Note = styled.div`
  background: #feecde;
  border-radius: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  gap: 4px;
  color: #332927;
  margin-top: 10px;
`;

export const IconCopyPaste = styled(CopyPaste)`
  color: #332927;
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
export const IconExchange = styled(Cambiar)`
  color: #332927;
  width: 20px;
  height: 20px;
`;
export const IconHistory = styled(Historial)`
  color: #332927;
  width: 20px;
  height: 20px;
`;
export const IconCancel = styled(Cancel)`
  color: #332927;
  width: 20px;
  height: 20px;
`;
export const IconHelp = styled(Ayuda)`
  color: #332927;
  width: 20px;
  height: 20px;
`;
export const IconChevron = styled(Chevron)`
  color: #332927;
  width: 16px;
  height: 16px;
`;
export const IconEmail = styled(Email)`
  color: #332927;
  width: 20px;
  height: 20px;
`;
export const AirIcon = styled.img`
  height: 20px;
  max-width: 30px;
`;

export const IconInfo = styled(Info)`
  color: #ff6500;
  width: 18px;
  height: 18px;
`;
